<template>
    <div>
        <h2 class="mb-1">{{ $t("settings.account.Personal preferences") }}</h2>

        <validation-provider #default="{ errors }" name="language" rules="required">
            <b-form-group
                id="fieldset-language"
                :label="$t('locale.Language')"
                :state="errors.length > 0 ? false : null"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="language"
            >
                <b-form-select
                    id="language"
                    v-model="getSettingByName('language', 'en').value"
                    :options="availableLanguages"
                    :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>

            <b-form-group
                id="fieldset-timeNotation"
                :label="$t('locale.timeNotation')"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="timeNotation"
            >
                <b-form-radio-group
                    id="time-notation-radio"
                    v-model="getSettingByName('timeNotation', '24').value"
                    :options="availableTimeNotations"
                    button-variant="light"
                    buttons
                    name="time-notation-radio"
                ></b-form-radio-group>
            </b-form-group>

            <b-form-group
                id="fieldset-enterToSend"
                :description="$t('settings.account.enterToSend.description')"
                :label="$t('settings.account.enterToSend.label')"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="enterToSend"
            >
                <b-form-checkbox
                    v-model="getSettingByName('enterToSend', '1').value"
                    inline
                    name="enterToSend"
                    switch
                    unchecked-value="0"
                    value="1"
                />
            </b-form-group>

            <b-form-group
                id="fieldset-rightSideMenu"
                :description="$t('settings.account.rightSideMenuIsOpen.description')"
                :label="$t('settings.account.rightSideMenuIsOpen.label')"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="rightSideMenu"
            >
                <b-form-checkbox
                    v-model="getSettingByName('rightSideMenuIsOpen', '0').value"
                    inline
                    name="rightSideMenu"
                    switch
                    unchecked-value="0"
                    value="1"
                />
            </b-form-group>
        </validation-provider>

        <hr />
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import i18n from "@/libs/i18n/index";
import {
    BRow,
    BCol,
    BContainer,
    BCard,
    BFormGroup,
    BFormInput,
    BFormRadio,
    BFormCheckbox,
    BFormSelect,
    BFormRadioGroup,
} from "bootstrap-vue";
import useUserAccounts from "../useUserAccounts";

export default {
    components: {
        BRow,
        BCol,
        BContainer,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BFormRadio,
        BCard,
        ValidationProvider,
        ValidationObserver,
        BFormSelect,
        BFormRadioGroup,
    },
    props: {
        userData: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { getSettingByName } = useUserAccounts(props.userData);

        return {
            getSettingByName,
        };
    },
    data() {
        return {
            required,
            availableLanguages: [
                {
                    text: i18n.t("locale.languages.dutch"),
                    value: "nl",
                },
                {
                    text: i18n.t("locale.languages.english"),
                    value: "en",
                },
                {
                    text: i18n.t("locale.languages.spanish"),
                    value: "es",
                },
            ],
            availableTimeNotations: [
                {
                    text: "20:45",
                    value: "24",
                },
                {
                    text: "8:45 p.m.",
                    value: "12",
                },
            ],
        };
    },
};
</script>

<style lang="scss">
@import "~@core/scss/vue/libs/vue-select.scss";
</style>
